var _rect, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgWhiteboard = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 32,
    height: 32,
    rx: 8,
    fill: "white",
    stroke: "var(--asset-color)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4501 9.46784C17.4501 9.20943 17.2406 9 16.9823 9C16.7239 9 16.5144 9.20943 16.5144 9.46784V10.0688H17.4501V9.46784ZM23.814 16.6244C23.641 16.5941 23.4621 16.5785 23.2793 16.5785H10.6802C10.4974 16.5785 10.3183 16.5941 10.1455 16.6244V12.4699C10.1455 11.6672 10.8865 11 11.8254 11H22.1339C23.0515 11 23.814 11.6484 23.814 12.4699V16.6244ZM10.68 17.5143H23.2794C24.2058 17.5143 24.9595 18.1738 24.9595 18.9843C24.9595 19.7949 24.2058 20.4544 23.2794 20.4544H10.68C9.7537 20.4544 9 19.795 9 18.9843C9 18.1738 9.7537 17.5143 10.68 17.5143ZM15.8001 23.4656L16.112 22.53H17.8524L18.1643 23.4656H15.8001ZM13.5317 24.3529C13.4379 24.6343 13.6334 24.9689 13.9755 24.9689C14.1715 24.9689 14.3542 24.8448 14.4194 24.6489L15.5042 21.3946H14.5179L13.5317 24.3529ZM18.4603 21.3946H19.4465L20.4327 24.3529C20.5307 24.6464 20.3176 24.9689 19.9889 24.9689C19.793 24.9689 19.6106 24.8451 19.545 24.6489L18.4603 21.3946Z",
    fill: "var(--asset-color)"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWhiteboard, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/whiteboard.b67aa5f9.svg";
export { ForwardRef as ReactComponent };